// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"388b7b8d","732":"21a07b22","977":"144f2441"}[chunkId] + ".chunk.js";
};